<template>
    <div class="generalframezz">
        <div class="generalcontent" style="width: 420px;height: 328px;">
            <div style="height:82px;lineHeight:82px;" class="general_title">
                <div class="general_title_left">
                    <img style="display:inline-block" class="timgtishi" src="./images/exchange.png" alt='版权登记'/>
                    <div>会员激活码兑换</div>
                </div>
                <img @click="parentHandleclick" class="timgclose" src="./images/ty_close.png" alt='版权登记'/>
            </div>
            <div class="container">
                <input v-model="code" placeholder="请输入会员激活码"/>
                <button class="btn" @click="exchange">兑换</button>
            </div>
        </div>
    </div>
</template>

<script>
    import {_exchange} from "../../../../api/activity";

    export default {
        name:'generalframe',
        data(){
            return{
                code:''
            }
        },
        methods:{
            parentHandleclick() {
                this.$emit('fatherMethod');
            },
            exchange(){
                let codeReg = /^[0-9a-zA-Z]+$/ ;
                if(!codeReg.test(this.code)){
                    toast("请输入正确的激活码，激活码只包含数字和字母")
                    return false ;
                }else if(this.code.length >32){
                    toast("请输入正确的激活码，激活码不会超过32位")
                }
                let params = {
                    code: this.code
                };
                console.log("code ::: ",params);
                _exchange(params).then((res)=>{
                    if(res.code == "200"){
                        toast("兑换成功")
                        this.parentHandleclick();
                    }else{

                    }
                });
            }
        },
    }
</script>

<style scoped lang="less">
    .generalframezz{
        background: rgba(0, 0, 0, 0.7);
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        text-align: center;
        margin: auto;
        z-index: 558;
        display: flex;
        justify-content: center;
        align-items: center;
        .generalcontent{
            // overflow-y: scroll;
            background:#fff;
            /*position: absolute;*/
            /*left: 0;*/
            /*right: 0;*/
            /*top: 0;*/
            /*bottom: 0;*/
            /*margin: auto;*/
            border-radius:8px;
            .general_title{
                border-bottom:1px solid rgba(236,236,236,1);
                font-size:16px;
                font-weight:400;
                color:rgba(50,50,50,1);
                display:flex;
                justify-content: space-between;
                padding:0 30px;
                align-items: center;
                .general_title_left{
                    display:flex;
                    justify-content: flex-start;
                    align-items: center;
                }
                .timgtishi{
                    width:25px;
                    height:25px;
                    margin-right:10px;
                }
                .timgclose{
                    width:18px;
                    height:18px;
                    cursor: pointer;
                }
            }

            .container{
                display: flex;
                flex-direction: column;
                align-items: center;

                input{
                    width:289px;
                    height:46px;
                    background:rgba(255,255,255,1);
                    border-radius:4px;
                    border:1px solid rgba(230,232,236,1);
                    outline: none;
                    padding-left: 19px;
                    margin-top: 37px;
                }
                input:hover,input:focus{
                    border:1px solid rgba(230,232,236,1);
                }

                .btn{
                    width:150px;
                    height:37px;
                    background:rgba(255,215,1,1);
                    border-radius:19px;
                    font-size:14px;
                    font-weight:400;
                    color:rgba(40,40,40,1);
                    outline: none;
                    border: none;
                    margin-top: 66px;
                    cursor: pointer;
                }
            }
        }




    }
</style>